// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spots-grid {
  display: grid;
  gap: 16px;
  margin: 0;
  grid-template-columns: repeat(var(--grid-cols-mobile), 1fr);
}
@media (min-width: 768px) {
  .spots-grid {
    grid-template-columns: repeat(var(--grid-cols-tablet), 1fr);
  }
}
@media (min-width: 1024px) {
  .spots-grid {
    grid-template-columns: repeat(var(--grid-cols-desktop), 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/storyblok/components/storyblok-spots-v2/storyblok-spots-v2.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,SAAA;EAGA,2DAAA;AADF;AAIE;EATF;IAUI,2DAAA;EADF;AACF;AAIE;EAdF;IAeI,4DAAA;EADF;AACF","sourcesContent":[".spots-grid {\n  display: grid;\n  gap: 16px;\n  margin: 0;\n\n  // Mobile first approach\n  grid-template-columns: repeat(var(--grid-cols-mobile), 1fr);\n\n  // Tablet breakpoint\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(var(--grid-cols-tablet), 1fr);\n  }\n\n  // Desktop breakpoint\n  @media (min-width: 1024px) {\n    grid-template-columns: repeat(var(--grid-cols-desktop), 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
